import React from "react";
import { useForm } from "react-hook-form";
import ReloadButton from "./ReloadButton/ReloadButton.js"

export default function Form({ setState, state }) {
    // const navigate = useNavigate();
    const { register, handleSubmit } = useForm();
    const onSubmit = (data) => {
        setState(data)
        // console.log(data)
        return data
    }
    // console.log(state)
    return (
        <div className="container">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group row" >
                    <div className="form-group col-md-6 pt-md-6" style={{ marginTop: '1rem' }}>
                        <label htmlFor="gravity">Label the case</label>
                        <input className="form-control" name="name" placeholder="default noName" {...register("name")} defaultValue={"noName"} />
                    </div>
                    <div className="form-group col-md-6 pt-md-6" style={{ marginTop: '1rem' }}>
                        <label htmlFor="mass">Mass (kg)</label>
                        <input type="number" className="form-control" name="mass" placeholder="default 50" {...register("mass")} defaultValue={50} />
                    </div>
                </div>

                <div className="form-group row" >
                    <div className="form-group col-md-6 pt-md-6" style={{ marginTop: '1rem' }}>
                        <label htmlFor="length-l" ><span className="h4 fst-italic fw-bold" style={{ fontFamily: "Times New Roman" }}> l</span> (cm)</label>
                        <input type="number" className="form-control" name="l" placeholder="default 5" {...register("l")} defaultValue={5} />
                    </div>
                    <div className="form-group col-md-6" style={{ marginTop: '1rem' }}>
                        <label htmlFor="width-M"><span className="h4 fst-italic fw-bold" style={{ fontFamily: "Times New Roman" }}>M</span> (cm)</label>
                        <input type="number" className="form-control" name="M" placeholder="default 15" {...register("M")} defaultValue={15} />
                    </div>
                </div>

                <div className="form-group row" >
                    <div className="form-group col-md-6 pt-md-6" style={{ marginTop: '1rem' }}>
                        <label htmlFor="angle-alpha">Alpha (degrees)</label>
                        <input type="number" className="form-control" name="alpha" placeholder="default 60" {...register("alpha")} defaultValue={60} />
                    </div>
                    <div className="form-group col-md-6" style={{ marginTop: '1rem' }}>
                        <label htmlFor="angle-beta">Beta (degrees)</label>
                        <input type="number" className="form-control" name="beta" placeholder="default 0" {...register("beta")} defaultValue={0} />
                    </div>
                </div>

                <div className="d-flex justify-content-between">
                    <button type='submit' className='btn btn-primary mt-3 mb-3' > Calculate </button>
                    <ReloadButton state={state}/>
                </div>

            </form>
        </div>

    )

}//  me-2 style={{ marginTop: '1rem' }}
